import {
  CycleCountSessionItem,
  RecordCountRequest,
} from '../models/cycle-count-session.model';

/**
 * #32233 (extracted from the web counting grid to keep the component under the file-size gate): build the
 * RecordCountRequest for an Actual-QTY edit. Parses the raw field value, and, per #31259 parity, records 0
 * good-on-hand (not null) when the field is blank but a broken qty is present and the row is not Not-Found —
 * the API requires ActualQty unless Not Found. Without a broken qty, a blank field stays null (un-records).
 */
export function recordCountRequestForActualQty(
  item: CycleCountSessionItem,
  value: string
): RecordCountRequest {
  const qty = value === '' ? null : parseFloat(value);
  const parsed = qty === null || Number.isNaN(qty) ? null : qty;
  const hasBroken = item.damagedQty != null && item.damagedQty > 0;
  const actualQty =
    parsed === null && hasBroken && !item.isNotFound ? 0 : parsed;
  return {
    actualQty,
    isDamaged: item.isDamaged,
    // #32221: preserve an already-recorded broken qty when the count changes.
    damagedQty: item.damagedQty,
    isNotFound: false,
    notes: item.notes,
  };
}

/**
 * #32233 (extracted): build the RecordCountRequest for toggling Not Found. Not Found is mutually exclusive
 * with a count/broken observation (mobile `resolveCycleCountEntry`), so toggling it ON clears the count AND
 * the damage flags — otherwise the server nulls DamagedQty but keeps a stale isDamaged=true, a contradictory
 * "not found yet broken" row.
 */
export function recordCountRequestForNotFoundToggle(
  item: CycleCountSessionItem
): RecordCountRequest {
  const isNotFound = !item.isNotFound;
  return {
    actualQty: isNotFound ? null : item.actualQty,
    isDamaged: isNotFound ? false : item.isDamaged,
    damagedQty: isNotFound ? null : item.damagedQty,
    isNotFound,
    notes: item.notes,
  };
}

/**
 * #32233 (extracted): build the RecordCountRequest for a Notes edit, preserving the count/broken/not-found
 * state and normalizing a blank note to null.
 */
export function recordCountRequestForNotes(
  item: CycleCountSessionItem,
  notes: string
): RecordCountRequest {
  return {
    actualQty: item.actualQty,
    isDamaged: item.isDamaged,
    damagedQty: item.damagedQty,
    isNotFound: item.isNotFound,
    notes: notes || null,
  };
}
